export enum SearchParam {
  MaxReturn = "count=-1"
}
